import { render, staticRenderFns } from "./welcome-skeleton.vue?vue&type=template&id=4ee72265&scoped=true&"
import script from "./welcome-skeleton.component.ts?vue&type=script&lang=ts&"
export * from "./welcome-skeleton.component.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ee72265",
  null
  
)

export default component.exports